import styled from 'styled-components';
import { media, space, rems, getSectionGradient } from '../../ui/helpers';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';

const CoursesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  background-color: ${colors.neutral[1000]};

  .courseSelectorTitle {
    ${fonts.titleMD};
    text-align: center;
    color: ${colors.neutral[100]};
  }

  .courseSelectorContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    padding-top: 2.5rem;
    padding-bottom: 2.5rem;

    ${media.max('medium')`
      padding-top: 0;
    `}

    ${media.max('small')`
      padding-top: 0;
    `}


    .courseSelector {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: ${space(20)};

      ${media.max('medium')`
        flex-direction: column;
        gap: ${space(5)};
      `}

      .evenCourses, .oddCourses {
        display: flex;
        gap: ${space(20)};
        text-align: center;
        text-wrap: nowrap;

        div {
          width: 50%;
        }

        ${media.max('medium')`
          gap: ${space(14)};
          text-wrap: wrap;
        `}
      }

      .courseWrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .courseText {
          ${fonts.highlightsMD}
          font-weight: 500 !important;
          color: ${colors.neutral[100]};
        }

        a {
          cursor: pointer;
          color: ${colors.neutral[100]};
          font-weight: 400;
        }

        .ageText {
          ${fonts.highlightsSM};
          color: ${colors.neutral[100]};
        }

        .babies, .maluchy {
          color: rgb(240, 135, 170);
        }

        .kids, .dzieci {
          color: rgb(160, 189, 117);
        }

        .tweens, .starsze {
          color: rgb(229, 111, 36);
        }

        .teens, .nastolatki {
          color: rgb(49, 183, 188);
        }
      }
    }
  }
`

const CoursesItem = styled.div`
  display: flex;
  flex-direction: ${(props) => props.position ? 'row' : 'row-reverse'};
  justify-content: space-around;
  align-items: center;

  height: fit-content;

  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  background-color: ${colors.neutral[1000]};

  ${media.max('medium')`
    flex-direction: column-reverse;
    justify-content: center;
    height: fit-content;

    padding-top: 2rem;
    padding-bottom: 2rem;
  `}

  .textButtonWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;

    width: 50%;

    ${media.max('medium')`
      align-items: center;
      width: 100%;
    `}
    
    .textWrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      ${media.max('medium')`
        text-align: center;
        align-items: center;
      `}

      span {
        color: ${colors.neutral[100]};
      }

      .title {
        ${fonts.titleLG};
      }

      .description {
        ${fonts.highlightsMD};
      }
    }

    .buttonWrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${colors.neutral[100]};
      border-color: ${colors.neutral[100]};
      border-radius: 0px;
      color: rgb(56, 56, 56);
      padding: ${space(1)} ${space(1)};
      height: 2.75rem !important;

      /* width: 50%; */
    }

    .buttonWrapper span {
      color: #000;
    }

    .buttonWrapper a {
      text-decoration: none;
    }
  }

  img {
    min-width: 10vw;
    max-width: 35vw;

    ${media.max('medium')`
      max-width: 42vh;
      margin-bottom: 3rem;
    `}

    ${media.max('small')`
      mad-width: 38vh;
      margin-bottom: 2rem;
    `}
  }
`

export { CoursesContainer, CoursesItem };
